(() => {
  if (customElements.get('collection-carousel')) {
    return;
  }

  class CollectionCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};
      this.gap = this.dataset.gap;
      this.slides = this.dataset.slides;

      this.sliderPrev = this.querySelector('.swiper-arrow--prev');
      this.sliderNext = this.querySelector('.swiper-arrow--next');
      this.play = this.querySelector('.swiper-play-button');
      this.autoplayEnabled = this.querySelector('[data-slider]').dataset.autoplay === 'true';
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      const slides = this.slides.split('@');

      let mobileSlides = 1.5;
      let tabletPSlides = 2.5;
      let tabletLSlides = 3.5;
      let desktopSlides = 4.7;

      let images = this.querySelectorAll('img');

      slides.forEach((slide, index) => {
        if (index == 0) {
          mobileSlides = Number(slide);
        }

        if (index == 1) {
          tabletPSlides = Number(slide);
        }

        if (index == 2) {
          tabletLSlides = Number(slide);
        }

        if (index == 3) {
          desktopSlides = Number(slide);
        }
      });

      this.sliderOptions = {
        slidesPerView: mobileSlides,
        centeredSlides: true,
        spaceBetween: Number(this.gap),
        breakpoints: {
          750: {
            centeredSlides: false,
            slidesPerView: tabletPSlides,
          },
          990: {
            centeredSlides: false,
            slidesPerView: tabletLSlides,
          },
          1200: {
            centeredSlides: false,
            slidesPerView: desktopSlides,
          },
        },
        navigation: {
          prevEl: this.sliderPrev,
          nextEl: this.sliderNext,
        },
        on: {
          slideChange: function () {
            images.forEach((image) => {
              image.setAttribute('loading','eager')
            });
          }
        }
      };

      if (this.autoplayEnabled) {
        this.sliderOptions.loop = true;
        this.sliderOptions.speed = 300;
        this.sliderOptions.autoplay = {
          delay: 0, // Set the autoplay delay in milliseconds
          disableOnInteraction: false,
        };
      }

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);

      this.setupAutoplay();
    }

    setupAutoplay() {
      this.slider.autoplay.stop();

      if (this.play != null) {
        this.play.addEventListener('click', ()=> {
          if (this.slider.autoplay.running) {
            // If autoplay is running, stop it and change the button text
            this.slider.autoplay.stop();
            this.slider.params.speed = 300;

            this.play.classList.add('stopped')
          } else {
            // If autoplay is not running, start it and change the button text
            this.slider.params.speed = 3000;
            this.slider.autoplay.start();
            this.play.classList.remove('stopped')
          }
        });
      };

      if (this.autoplayEnabled) {
        this.slider.params.speed = 3000;
        this.slider.autoplay.start();
      };
    }
  }

  customElements.define('collection-carousel', CollectionCarousel);
})();
